module.exports = __webpack_public_path__ + "static/media/book_03_loader.47b2ff28.svg";